import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";

const LETTERS = "ABCDEFGHIJKLMNPRSTV".split(""); // avoid tricky letters
const FIELDS = [
  { k: "name", label: "Name", ph: "e.g. Neha" },
  { k: "place", label: "Place", ph: "e.g. Nagpur" },
  { k: "animal", label: "Animal", ph: "e.g. Nilgai" },
  { k: "thing", label: "Thing", ph: "e.g. Notebook" },
];

export default function NamePlaceAnimalThing() {
  const [letter, setLetter] = useState(null);
  const [vals, setVals] = useState({ name: "", place: "", animal: "", thing: "" });
  const [time, setTime] = useState(30);
  const [phase, setPhase] = useState("idle"); // idle | play | over
  const [score, setScore] = useState(0);
  const timer = useRef(null);

  const start = () => {
    const l = LETTERS[Math.floor(Math.random() * LETTERS.length)];
    setLetter(l); setVals({ name: "", place: "", animal: "", thing: "" }); setTime(30); setPhase("play"); setScore(0);
    timer.current = setInterval(() => setTime((t) => { if (t <= 1) { clearInterval(timer.current); submit(); return 0; } return t - 1; }), 1000);
  };

  const submit = () => {
    clearInterval(timer.current);
    setPhase("over");
    setVals((v) => {
      let s = 0;
      FIELDS.forEach((f) => { const txt = v[f.k].trim().toLowerCase(); if (txt && letter && txt[0] === letter.toLowerCase()) s += 10; });
      setScore(s);
      return v;
    });
  };

  useEffect(() => () => clearInterval(timer.current), []);

  return (
    <div className="w-full text-center">
      {phase === "idle" ? (
        <div>
          <p className="mb-4 text-sm text-kirana-brown/70">The classic bench game! You'll get a letter — fill all 4 before the timer runs out. +10 each.</p>
          <ABtn data-testid="npat-start" onClick={start} tone="red" className="px-8 py-3">Roll a Letter 🎲</ABtn>
        </div>
      ) : (
        <>
          <div className="flex items-center justify-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-full border-[3px] border-kirana-brown bg-kirana-gold font-signboard text-2xl font-bold text-kirana-brown" data-testid="npat-letter">{letter}</span>
            <span data-testid="npat-timer" className={`rounded-md border-2 border-kirana-brown bg-white px-3 py-1.5 font-bold ${time <= 5 ? "text-kirana-red" : "text-kirana-brown"}`}>⏱ {time}s</span>
          </div>
          <div className="mx-auto mt-4 flex max-w-sm flex-col gap-2">
            {FIELDS.map((f) => (
              <div key={f.k} className="flex items-center gap-2">
                <label className="w-16 shrink-0 text-right text-sm font-bold text-kirana-brown">{f.label}</label>
                <input data-testid={`npat-${f.k}`} disabled={phase === "over"} value={vals[f.k]} placeholder={f.ph}
                  onChange={(e) => setVals((v) => ({ ...v, [f.k]: e.target.value }))}
                  className="flex-1 rounded-md border-2 border-kirana-brown bg-white px-3 py-2 text-sm font-semibold text-kirana-brown outline-none focus:border-kirana-red disabled:opacity-60" />
              </div>
            ))}
          </div>
          {phase === "play" ? (
            <div className="mt-4 flex justify-center"><ABtn data-testid="npat-submit" onClick={submit} tone="green">STOP! Submit</ABtn></div>
          ) : (
            <>
              <div className="mt-3 flex justify-center"><AScore label="Score" value={score} /></div>
              <AResult testId="npat-result" win={score > 0} text={score >= 40 ? "Full marks! 🌟" : score > 0 ? `You scored ${score}` : "Oops, none matched 😅"} />
              <div className="mt-3 flex justify-center"><ABtn data-testid="npat-again" onClick={start} tone="gold">New Letter</ABtn></div>
            </>
          )}
        </>
      )}
    </div>
  );
}
